import moment from 'moment'
export default {
	data () {
		return {}
	},
	computed: {},
	methods: {

		formatTime (timestamp) {
			let time = moment.utc(timestamp).fromNow();
			return time;
		},

		typeOfMsg (msg, i) {
			let customClass = {};
			let messages = this.messages;
			let myUsrId = this.getMyUsrId()
			if (msg.sender == myUsrId) customClass["my-msg"] = true;
			else customClass["their-msg"] = true;
			if (
				messages[i + 1] === undefined ||
				messages[i + 1] === null ||
				messages[i + 1].sender !== msg.sender
			)
				customClass["bot-round"] = true;
			if (
				messages[i - 1] === undefined ||
				messages[i - 1] === null ||
				messages[i - 1].sender !== msg.sender
			)
				customClass["top-round"] = true;

			return customClass;
		},

    areObjectsSame(x, y) {
      var objectsAreSame = true;
      let keysX = Object.keys(x);
      let keysY = Object.keys(y);
      if (keysX.length !== keysY.length) return false;
      // Create a set of keys - no duplicates
      // We expect most keys to overlap
      // In the event they don't - object will have a key that the other doesn't
      // which will cause an undefined !== to something
      let keysUnion = {};
      // From all keys from first object
      for (let i = 0; i < keysX.length; i++) {
        keysUnion[keysX[i]] = true;
      }
      // From all keys from second object
      for (let i = 0; i < keysY.length; i++) {
        // Optimization: If you find a key in the other object that doesn't exist in the first one
        // break early - objects are are not the same
        if (keysUnion[keysY[i]] !== true) {
          return false;
        }
      }

      let allKeys = Object.keys(keysUnion);

      // Check both object properties
      for (let i = 0; i < allKeys.length; i++) {
        let propertyName = allKeys[i];
        if (x[propertyName] != y[propertyName]) {
          objectsAreSame = false;
          break;
        }
      }
      return objectsAreSame;
		},
		
    arraysAreSame(x, y) {
      // returns code status
      if (x.length == 0 || x.length !== y.length) return 1;
      if (!this.areObjectsSame(x[x.length - 1], y[y.length - 1])) return 2;
      if (!this.areObjectsSame(x[0], y[0])) return 3;
      return 0;
		},

    shouldShowImage(msg, i) {
      let messages = this.messages;
      let myUsrId = this.getMyUsrId();
      if (
        msg.sender !== myUsrId &&
        (messages[i + 1] === undefined ||
          messages[i + 1] === null ||
          messages[i + 1].sender !== msg.sender)
      )
        return true;
		},
		
    reportMsg(msgId) {
      //emit
      let msg = {
        message: true,
        id: msgId,
      };
      this.$emit("report", msg);
		},
		
    scrollToRef() {
      if (!this.topMsgId) return;
      let ref = "msg" + this.topMsgId;
      let scrollTarget = this.$refs[ref];
      scrollTarget = scrollTarget ? scrollTarget[0] : null;

      if (scrollTarget) scrollTarget.scrollIntoView();
		},
		
    scrollToLast() {
      if (this.messages.length <= 0) return;
      setTimeout(() => {
        let noOfMsg = this.messages.length;
        if (noOfMsg < 4) return;
        let lastId = this.messages[noOfMsg - 1].id;
        let msgId = "msg" + lastId;
        let msg = this.$refs[msgId][0];
        msg.scrollIntoView();
      }, 0);
		},
		
		stopUpdate() {
      if (this.refresTimer) {
        clearInterval(this.refresTimer);
        this.refresTimer = null;
      }
		},

    senderNotMe(msg) {
			let myUsrId = this.getMyUsrId();
      if (msg.sender != myUsrId) {
        return true;
      }
		},
		
    showScrollToBottomButton(bool) {
      this.hasNewMsg = bool;
		},
		
    clickScrollToBottom() {
      this.showScrollToBottomButton(false);
      this.scrollToLast();
    },
	}
}